<template>
  <div class="oil-manage">
    <!-- 页面标题和统计卡片 -->
    <div class="page-header">
      <h2>加油统计</h2>
      <div class="header-summary">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="summary-card">
              <div class="card-title">总加油量</div>
              <div class="card-amount">{{totalCount}} <span class="unit">L</span></div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-card">
              <div class="card-title">挖机加油量</div>
              <div class="card-amount">{{excavatorCount || 0}} <span class="unit">L</span></div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-card">
              <div class="card-title">自卸车加油量</div>
              <div class="card-amount">{{dumpTruckCount || 0}} <span class="unit">L</span></div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-card">
              <div class="card-title">其他加油量</div>
              <div class="card-amount">{{getOtherTotal()}} <span class="unit">L</span></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 操作栏 -->
    <div class="operation-bar">
      <div class="right-operations">
        <el-form :model="searchForm.formData" :inline="true" size="small">
          <el-form-item label="车辆编号">
            <el-input
              v-model.trim="searchForm.formData.name"
              placeholder="请输入车辆编号"
              prefix-icon="el-icon-search"
              clearable
            />
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="searchForm.formData.dateRange"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['6:00:00','6:00:00']"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="date-picker"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search" icon="el-icon-search">搜索</el-button>
            <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
            <el-button @click="handleExport" type="el-icon-download" icon="el-icon-download">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 表格卡片 -->
    <el-card class="table-card" shadow="hover">
      <el-table
        :data="table.tableData"
        border
        stripe
        row-key="id"
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
      >
        <el-table-column prop="sid" label="加油设备" min-width="30" align="center" />
        <el-table-column prop="name" label="车辆编号" min-width="20" align="center" />
        <el-table-column prop="updateCode" label="修改车号" min-width="20" align="center">
          <template #default="scope">
            <el-input
              v-if="scope.row.editing"
              v-model="scope.row.updateCode"
              size="mini"
              @blur="handleUpdateCode(scope.row)"
              @keyup.enter="handleUpdateCode(scope.row)"
            />
            <span v-else @click="startEdit(scope.row)" class="editable-cell">
              {{ scope.row.updateCode || scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="车辆类型" min-width="30" align="center" />
        <el-table-column prop="count" label="加油数量" min-width="30" align="center">
          <template #default="scope">
            <span class="amount">{{ scope.row.count }} L</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderEndTime" label="加油时间" min-width="30" align="center" />
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total,sizes,prev,pager,next,jumper"
          :page-size="table.pageConfig.size"
          :page-sizes="[5, 10, 15, 20]"
          :total="table.pageConfig.total"
          :current-page.sync="table.pageConfig.current"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import {getList, exportOil, updateCode} from "@/api/oil";
import moment from 'moment';

export default {
  name: '',
  data() {
    // 获取今天和昨天的日期
    const now = new Date()
    const yesterday = new Date(now)
    yesterday.setDate(yesterday.getDate() - 1)

    // 设置时间为早上6点
    yesterday.setHours(6, 0, 0)
    now.setHours(6, 0, 0)

    return {
      searchForm: {
        deptList: [],
        formData: {
          name: '',
          dateRange: [yesterday, now] // 直接使用Date对象
        }
      },
      dialogVisible: false,
      dialogImageUrl: '',
      totalCount: '',
      excavatorCount: 0,
      dumpTruckCount: 0,
      graderCount: 0,
      waterTruckCount: 0,
      loaderCount: 0,
      otherCount: 0,
      table: {
        tableData: [],
        pageConfig: {
          total: 10, // 记录总数
          current: 1, // 起始页
          size: 10 // 每页显示的记录数
        }
      },
      tableHeaderStyle: {
        background: '#f5f7fa',
        color: '#606266',
        textAlign: 'center',
        fontWeight: 'bold',
        borderColor: '#ebeef5',
        padding: '12px 0'
      },
      tableCellStyle: {
        textAlign: 'center'
      }
    }
  },
  methods: {
    loading() {
      // 如果dateRange存在才进行格式化
      if (this.searchForm.formData.dateRange && this.searchForm.formData.dateRange.length === 2) {
        const startTime = this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[0])
        const endTime = this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[1])

        getList({
          current: this.table.pageConfig.current,
          size: this.table.pageConfig.size,
          name: this.searchForm.formData.name,
          startTime: startTime,
          endTime: endTime,
          isGroup: false,
          deptId: this.$store.state.staff.staff.deptId
        }).then(response => {
          if (response.code === 200) {
            this.table.tableData = response.data.list
            this.table.pageConfig.total = response.data.total
            this.totalCount = response.data.totalCount
            this.excavatorCount = response.data.excavatorCount
            this.dumpTruckCount = response.data.dumpTruckCount
            this.graderCount = response.data.graderCount
            this.waterTruckCount = response.data.waterTruckCount
            this.loaderCount = response.data.loaderCount
            this.otherCount = response.data.otherCount
          } else {
            this.$message.error(response.message)
          }
        })
      }
    },
    formatDateToYYYYMMDDHHMMSS (date1) {
      const date = new Date(date1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    },
    handleSizeChange (size) {
      this.table.pageConfig.size = size
      this.loading()
    },
    handleCurrentChange (current) {
      this.table.pageConfig.current = current
      this.loading()
    },
    search () {
      this.loading()
    },
    reset() {
      // 重置时设置回默认时间范围
      const now = new Date()
      const yesterday = new Date(now)
      yesterday.setDate(yesterday.getDate() - 1)
      yesterday.setHours(6, 0, 0)
      now.setHours(6, 0, 0)

      this.searchForm.formData = {
        name: '',
        dateRange: [yesterday, now]
      }
      this.loading()
    },
    handleExport() {
      // 构建查询参数
      const params = {
        name: this.searchForm.formData.name || '',
        startTime: this.searchForm.formData.dateRange ? this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[0]) : '',
        endTime: this.searchForm.formData.dateRange ? this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[1]) : '',
        deptId: this.$store.state.staff.staff.deptId
      }

      exportOil(params).then(response => {
        // 创建blob对象
        const blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        })
        // 创建下载链接
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `加油统计表_${moment().format('YYYYMMDDHHmmss')}.xlsx`
        link.click()
        // 释放URL对象
        window.URL.revokeObjectURL(link.href)
        }).catch(err => {
        this.$message.error('导出失败')
        console.error(err)
      })
    },
    startEdit(row) {
      this.$set(row, 'editing', true)
      this.$set(row, 'updateCode', row.updateCode || row.name)
    },
    handleUpdateCode(row) {
      if (row.updateCode && row.updateCode.trim() !== '') {
        updateCode(row.id, row.updateCode.trim()).then(response => {
          if (response.code === 200) {
            this.$message.success('车号和类型更新成功')
            this.$set(row, 'editing', false)
            // 更新成功后刷新页面数据
            this.loading()
          } else {
            this.$message.error(response.message || '更新失败')
          }
        }).catch(err => {
          this.$message.error('更新失败')
          console.error(err)
        })
      } else {
        this.$set(row, 'editing', false)
      }
    },
    // 计算其他类型的总和（除了挖机和自卸车之外的所有类型）
    getOtherTotal() {
      const grader = parseFloat(this.graderCount) || 0
      const waterTruck = parseFloat(this.waterTruckCount) || 0
      const loader = parseFloat(this.loaderCount) || 0
      const other = parseFloat(this.otherCount) || 0
      return (grader + waterTruck + loader + other).toFixed(2)
    }
  },
  created () {
    this.loading()
  }
}
</script>
<style lang="scss" scoped>
.oil-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 40px);

  .page-header {
    margin-bottom: 24px;

    h2 {
      margin: 0 0 16px;
      color: #1f2f3d;
      font-weight: 500;
    }

    .header-summary {
      margin-top: 20px;
    }

    .summary-card {
      background: #fff;
      padding: 15px;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      }

      .card-title {
        color: #909399;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .card-amount {
        color: #303133;
        font-size: 24px;
        font-weight: bold;

        .unit {
          font-size: 14px;
          color: #909399;
          margin-left: 4px;
        }
      }
    }
  }

  .operation-bar {
    background: #fff;
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);

    .date-picker {
      width: 360px;
    }
  }

  .table-card {
    margin-bottom: 20px;

    .amount {
      color: #409EFF;
      font-weight: bold;
    }
  }

  .pagination-container {
    padding: 15px 0;
    text-align: right;
  }

  :deep(.el-table) {
    margin-top: 10px;
  }

  .editable-cell {
    cursor: pointer;
    color: #409EFF;
    
    &:hover {
      background-color: #f5f7fa;
      padding: 2px 4px;
      border-radius: 4px;
    }
  }
}
</style>
